module.exports = __webpack_public_path__ + "img/cisco.24514e99.svg";